
function InitLoginPage(arg) {
   
    $(document).ready(function () {
    //    $('.login-info-box').fadeOut();
   //     $('.login-show').addClass('show-log-panel');
    });


    //$('.login-reg-panel input[type="radio"]').on('change', function () {
       
    //    if ($('#log-login-show').is(':checked')) {
    //        $('.register-info-box').fadeOut();
    //        $('.login-info-box').fadeIn();

    //        $('.white-panel').addClass('right-log');
    //        $('.register-show').addClass('show-log-panel');
    //        $('.login-show').removeClass('show-log-panel');

    //    }
    //    else if ($('#log-reg-show').is(':checked')) {
    //        $('.register-info-box').fadeIn();
    //        $('.login-info-box').fadeOut();

    //        $('.white-panel').removeClass('right-log');

    //        $('.login-show').addClass('show-log-panel');
    //        $('.register-show').removeClass('show-log-panel');
    //    }
    //});
}

window.clientJsMethods = {
    RedirectTo: function (path) {
        if (release) {
            path = '/app' + path;
        }
        window.location = path;
        }
    };


function RedirectTo(path) {
    if (release) {
        path = '/app' + path;
    }
    window.location = path;
}

function RedirectToRaw(path) {
    window.location = path;
}


function ShowSuccessRegistration() {
    swal({
        title: "Success!",
        text: "Registration successful\n\nClick the verification link in the verification email we've sent you and click OK to go to login.\n\nMake sure to check your spam inbox in case you do not receive a verification email.\n",
        type: "success",
        showCancelButton: false,
        showConfirmButton: true
    },
    function () {

        //if (release) {
        //    RedirectTo("/login");
        //} else {
        //    RedirectTo("login");
        //}
           
    });

    //swal({
    //    title: "Confirmation",
    //    text: 
    //    type: "info",
    //    showCancelButton: true,
    //    confirmButtonClass: "btn-success",
    //    confirmButtonText: "Yes, send.",
    //    closeOnConfirm: false
    //},
    //    function () {
    //        DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnSendManualNotificationConfirmed', '-');


    //        swal("Notification" + (sendtext & sendemail ? "s" : "") + " sent", "See the analytics page to see the statuses of all notifications", "success");

    //    });

}